/** @jsx jsx */
// eslint-disable-next-line
import React from 'react'
import { css, jsx } from '@emotion/core'
import Button from '@material-ui/core/Button'

const styles = {}
styles.container = css`
  position: fixed;
  height: 20px;
  width: 20px;
  top: 20px;
  right: 68px;
  z-index: 300;
`
styles.question = css`
  border: 2px solid #fff;
  font-size: 12px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  background: #fff;
  color: #000;
  font-weight: bold;
`
styles.button = {
  width: 20,
  height: 35
}

const DocsBotWidgetButton = () => {
  const [isOpen, setIsOpen] = React.useState(false)

  const onClick = () => {
    setIsOpen(!isOpen)
  }

  return (
    <React.Fragment>
      <div css={styles.container}>
        <Button aria-haspopup="true" style={styles.button} onClick={onClick}>
          <span css={styles.question}>?</span>
        </Button>
      </div>
      <iframe
        title="DocsBot Widget"
        src="https://docsbot.ai/iframe/KWJbKQlWPgbOlhPFcsGC/BaP3EcEhmhQBXqINVIO4"
        width="400"
        height="600"
        frameBorder="0"
        allowTransparency="true"
        scrolling="no"
        css={css`
          position: fixed;
          top: 75px;
          right: 20px;
          z-index: 300;
          box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
          border-radius: 8px;
          overflow: hidden;
          display: ${isOpen ? 'block' : 'none'};
        `}
      />
    </React.Fragment>
  )
}

export default DocsBotWidgetButton
